import React, { PureComponent } from 'react'
import {
  TableRow,
  TableCell,
  Button,
  MenuItem, // add menuitems
  LinearProgress,
} from '@material-ui/core'
import EditActionComponent from '../common/EditActionComponent'
import {
  EditableTextField,
  EditableReactSelectCreatable,
  EditableSwitch,
  EditableSelect,
} from '../common/EditableComponents'

import { TableCellWithTextField, TableCellWithSwitch } from '../common/PureItems' // add

import GooglePlacesAddress from '../common/GooglePlacesAddress'
import { hasAccess } from '../../utils/api'
import { Appcues, regionZoneTypes } from '../../utils/constants'
import KmlUtils from '../../utils/kml-utils'
import { uploadAssetAPI } from '../../api/assets'
import { openErrorMessage } from '../../actions/message'
import { connect } from 'react-redux'
import ModalDialog from '../common/ModalDialog'
import { getRegions } from '../../actions/company'
import { ColorSwatch, EditableColorPicker } from '../common/ColorPicker'
import RegionBaseItem from './RegionBaseItem'
import RegionDispatchItem from './RegionDispatchItem'
class RegionItem extends PureComponent {
  state = {
    location: null,
    loading: false,
    selectedKML: null,
  }

  componentDidMount() {
    const { data = {} } = this.props
    this.getAddressFromLatLng(data)
  }

  componentWillReceiveProps(nextProps) {
    const { data = {}, locationChanged } = nextProps

    /* if(data.latitude != this.props.data.latitude || data.longitude != this.props.data.longitude) {
            this.getAddressFromLatLng(data);
        } */
    if (locationChanged != this.props.locationChanged) {
      // eslint-disable-line

      this.getAddressFromLatLng(data)
    }
  }

  onChange =
    (key, isCheckBox = false) =>
    (event) => {
      const value = isCheckBox ? event.target.checked : event.target.value

      this.props.onChange(key, value)
    }

  onColorChange = (key) => (color) => {
    this.props.onChange(key, color.hex)
  }

  onChangeZipcodes = (zipCodes) => {
    let updatedZipcodes = []
    zipCodes =
      zipCodes &&
      zipCodes.filter((zipcode) => {
        return zipcode.value && zipcode.value.trim()
      })
    zipCodes.forEach((zipcode) => {
      updatedZipcodes.push(...zipcode.value.split(','))
    })

    this.props.onChange('zipCodes', updatedZipcodes)
  }

  onChangeAddress = (key) => (address, location) => {
    const { latitude, longitude } = location

    this.props.onChange('latitude', latitude)
    this.props.onChange('longitude', longitude)
    //this.getAddressFromLatLng(location);
  }

  getAddressFromLatLng = ({ latitude, longitude }) => {
    const { Geocode } = this.props
    if (latitude && longitude) {
      Geocode.fromLatLng(latitude, longitude).then(
        (response) => {
          const address = response.results[0].formatted_address
          this.setState({
            location: address,
          })
        },
        (error) => {
          //console.error(error);
        },
      )
    }
  }

  onSave = (region) => {
    this.props.onSave(() => this.props.disableEdit())
  }

  onDelete = () => {
    const { data } = this.props
    this.props.onDelete(data)
    Appcues.track('Region Deleted')
  }

  onCancel = () => {
    this.props.onCancel()
  }

  //edit regions

  editRegion = (id) => {
    this.props.history.push(`/settings/company/regions/${id}/edit`)
  }

  getmodalDeleteRegion = () => {
    this.modalDeleteRegion.handleClickOpen()
    console.log('delete')
  }

  onConfirm = () => {
    this.onDelete()
    this.modalDeleteRegion.handleClose()
  }

  handleButtonFile(e, currentRegion) {
    var file = e.target.files[0]
    const kmlUtils = new KmlUtils()
    let fileReader = new FileReader()

    if (file) {
      fileReader.onload = async (e) => {
        let result = await kmlUtils.extractGoogleCoords(e.target.result)
        if (result && result.polygons && result.polygons.length > 1) {
          this.props.dispatch(openErrorMessage(`KML must contain only one polygon.`))
        } else {
          const { kmlEdges = [] } = currentRegion
          let coordinates =
            result && result.polygons && result.polygons.length > 0 && result.polygons[0]
          //validate fileName
          if (this.checkDuplicateKmlFileName(file.name)) {
            //kml has same name
            this.props.dispatch(openErrorMessage('File already exist, please choose another one.'))
            this.setState({ loading: false })
            return
          }

          //validate coordinates in current region
          let duplicateKmlValidation = this.checkDuplicateKmlCoordinates(coordinates) || {}
          if (duplicateKmlValidation.isDuplicated) {
            //kml has same coordinate
            this.props.dispatch(
              openErrorMessage(
                `Coordinates already exist in this region, please choose another file.`,
              ),
            )
            this.setState({ loading: false })
            return
          }

          //validate coordinates in all regions
          let duplicateAllKmlValidation = this.checkAllDuplicateKmlCoordinates(coordinates)
          if (duplicateAllKmlValidation) {
            //kml has same coordinate
            this.props.dispatch(
              openErrorMessage(
                `Coordinates already exist in other region, please choose another file.`,
              ),
            )
            this.setState({ loading: false })
            return
          }

          uploadAssetAPI(file, 'kml')
            .then((response) => {
              let newKmlEdge = {
                active: false,
                coordinates: coordinates,
                asset: response,
              }
              this.setState({
                loading: false,
              })
              this.props.onChange('kmlEdges', [...kmlEdges, newKmlEdge])
              this.onChangeKmlEdge({ value: newKmlEdge })
            })
            .catch(function (error) {
              console.log(error)
              this.setState({ loading: false })
            })
        }
      }

      fileReader.readAsText(file)
    }
  }

  deleteKmlFile = (region, selectedKmlEdge) => {
    const currentKmls = region.kmlEdges || []
    const newKmls = currentKmls.filter((cKml) => cKml.asset.id != selectedKmlEdge.id)
    this.props.onChange('kmlEdges', newKmls)
  }

  onChangeZoneType = (zoneType) => {
    this.props.onChange('zoneType', zoneType ? zoneType.value : '')
  }

  onChangeAllowedConsumerType = (consumerType) => {
    let value =
      (consumerType &&
        consumerType.length &&
        consumerType.map((consumerType) => consumerType.value)) ||
      []
    this.props.onChange('allowedConsumerTypes', value)
  }

  onChangeKmlEdge = (selectedOption) => {
    const { data = {} } = this.props
    const { kmlEdges = [] } = data
    let disabledKmlEdge = []

    if (selectedOption) {
      const kmlEdge = selectedOption.value

      //enable selected kmlEdges
      let enalbedKmlEdge = {
        ...kmlEdge,
        active: true,
      }
      //disable the rest of kmlEdges
      //disable the rest of kmlEdges
      //disable the rest of kmlEdges
      let filteredKmlEdges = kmlEdges.filter(
        (item) => item.asset && item.asset.id !== kmlEdge.asset.id,
      )

      for (let kmlEdge of filteredKmlEdges) {
        let item = {
          ...kmlEdge,
          active: false,
        }
        disabledKmlEdge = [...disabledKmlEdge, item]
      }

      //set kmlEdges to object
      this.props.onChange('kmlEdges', [...disabledKmlEdge, enalbedKmlEdge])
    } else {
      for (let kmlEdge of kmlEdges) {
        let item = {
          ...kmlEdge,
          active: false,
        }
        disabledKmlEdge = [...disabledKmlEdge, item]
      }
      this.props.onChange('kmlEdges', disabledKmlEdge)
    }
  }

  formatKmlEdges = (kmlEdges) => {
    let options = []
    if (kmlEdges && kmlEdges.length > 0) {
      for (let kmlEdge of kmlEdges) {
        const { asset = {} } = kmlEdge
        let item = {
          label: asset.name,
          value: kmlEdge,
        }
        options = [...options, item]
      }
    }

    return options
  }

  getActiveKmlEdge = (region) => {
    let activeKmlEdges = region.kmlEdges && region.kmlEdges.filter((kml) => kml.active === true)
    let kmlData = (activeKmlEdges && activeKmlEdges.length > 0 && activeKmlEdges[0]) || {}
    let { asset = {} } = kmlData
    return asset
  }

  //this will check in all regions
  checkAllDuplicateKmlCoordinates = (coordinates) => {
    const { regions = [], data = {} } = this.props
    const kmlUtils = new KmlUtils()

    //getting all kmlEdges of each region
    let kmlEdgesOfRegions = []
    for (let region of regions) {
      if (region.kmlEdges && region.kmlEdges.length > 0 && region.id != data.id) {
        kmlEdgesOfRegions = [...kmlEdgesOfRegions, region.kmlEdges]
      }
    }

    let result = false
    for (let kmlEdgesOfRegion of kmlEdgesOfRegions) {
      for (let kmlEdge of kmlEdgesOfRegion) {
        if (kmlUtils.polygonsAreEqual(kmlEdge.coordinates, coordinates)) {
          result = true
          break
        }
      }

      if (result) {
        break
      }
    }

    return result
  }

  //this will check on the current region
  checkDuplicateKmlCoordinates = (coordinates) => {
    const { data = [] } = this.props
    const { kmlEdges = [] } = data
    const kmlUtils = new KmlUtils()

    let result = false
    let name = null
    for (let kmlEdge of kmlEdges) {
      if (kmlUtils.polygonsAreEqual(kmlEdge.coordinates, coordinates)) {
        result = true
        name = kmlEdge.asset && kmlEdge.asset.name
        break
      }
    }
    return { isDuplicated: result, name: name }
  }

  //check same names on current region
  checkDuplicateKmlFileName = (fileName) => {
    const { data = [] } = this.props
    const { kmlEdges = [] } = data

    let result = false
    for (let kmlEdge of kmlEdges) {
      const { asset = {} } = kmlEdge
      if (asset.name && asset.name === fileName) {
        result = true
        break
      }
    }

    return result
  }

  render() {
    //console.log("this.props-RegionItem", this.props)
    const {
      data = {},
      editMode = false,
      companyFeatures = {},
      regionConsumerTypeFlag = false,
    } = this.props
    const { location, loading } = this.state
    const { availableApps = [] } = companyFeatures
    const messageDeleteRegion = 'Are you sure want to delete the region?'

    let selectedZoneType =
      data.zoneType && regionZoneTypes.find((zoneType) => zoneType.value === data.zoneType)
    let selectedKmlEdge = this.getActiveKmlEdge(data)

    return availableApps.length > 0 && availableApps && availableApps.indexOf('Dispatch') < 0 ? (
      <RegionBaseItem
        data={data}
        onChange={this.onChange}
        onChangeAddress={this.onChangeAddress}
        onChangeZoneType={this.onChangeZoneType}
        handleButtonFile={this.handleButtonFile.bind(this)}
        setStateLoading={() => {
          this.setState({ loading: true })
        }}
        onChangeKmlEdge={this.onChangeKmlEdge}
        formatKmlEdges={this.formatKmlEdges}
        deleteKmlFile={this.deleteKmlFile}
        onChangeZipcodes={this.onChangeZipcodes}
        onSave={this.onSave}
        onCancel={this.props.onCancel}
        enableEdit={this.props.enableEdit}
        onDelete={this.onDelete}
        selectedZoneType={selectedZoneType}
        regionZoneTypes={regionZoneTypes}
        loading={loading}
        hasAccess={hasAccess}
        selectedKmlEdge={selectedKmlEdge}
        editMode={editMode}
        location={location}
        onChangeAllowedConsumerType={this.onChangeAllowedConsumerType}
        regionConsumerTypeFlag={regionConsumerTypeFlag}
      />
    ) : (
      <RegionDispatchItem
        data={data}
        onSave={this.onSave}
        onCancel={this.props.onCancel}
        enableEdit={this.props.enableEdit}
        onChange={this.onChange}
        onChangeZipcodes={this.onChangeZipcodes}
        onChangeAddress={this.onChangeAddress}
        onDelete={this.onDelete}
        editRegion={this.editRegion}
        getmodalDeleteRegion={this.getmodalDeleteRegion}
        handleClose={this.handleClose}
        onConfirm={this.onConfirm}
        onColorChange={this.onColorChange}
        modalDeleteRegion={(c) => (this.modalDeleteRegion = c)}
        location={location}
        editMode={editMode}
        messageDeleteRegion={messageDeleteRegion}
      />
    )
  }
}

export default connect()(RegionItem)



// WEBPACK FOOTER //
// ./src/components/Regions/RegionItem.js